import rtti from '@/sui/tools/rtti'

const debug = process.env.VUE_APP_SPIADI_DEBUG === '1'

function empty () {}

let assert = null
if (debug) {
  assert = function (t, m) {
    if (!rtti.isFunction(t)) {
      if (!t) {
        throw new Error(m)
      }
      return
    }

    const error = t()
    if (error != null) {
      throw new Error(`${m} ${error}`)
    }
  }

  assert.equals = function (v, e, m) {
    assert(v === e, `${m == null ? 'assert.equals' : m}: ${v} === ${e}`)
  }

  assert.isNull = function (t, m) {
    assert(t == null, m)
  }

  assert.notNull = function (t, m) {
    assert(t != null, m)
  }

  assert.create = function (f, d) {
    assert(rtti.isFunction(f), `${f} is not a function`)
    return function (a, m = d) {
      assert(f(a), m)
    }
  }

  assert.isFrozen = function (o, m) {
    assert(Object.isFrozen(o), m)
  }
} else {
  assert = empty
  assert.equals = empty
  assert.isNull = empty
  assert.notNull = empty
  assert.isFrozen = empty
  assert.create = function (f) {
    return empty
  }
}

assert.isBoolean = assert.create(rtti.isBoolean, 'Not a boolean')
assert.isObject = assert.create(rtti.isObject, 'Not an object')
assert.isArray = assert.create(rtti.isArray, 'Not an array')
assert.isString = assert.create(rtti.isString, 'Not a string')
assert.isArrayOrObject = assert.create(rtti.isArrayOrObject, 'Not an array or an object')
assert.isNumber = assert.create(rtti.isNumber, 'Not a number')
assert.isInteger = assert.create(rtti.isInteger, 'Not an integer')
assert.isFloat = assert.create(rtti.isFloat, 'Not a float')
assert.isFunction = assert.create(rtti.isFunction, 'Not a function')
assert.isRegExp = assert.create(rtti.isRegExp, 'Not a regexp')

export default assert
